import { createTheme } from "@mui/material/styles";

// Create a theme instance.
const theme = createTheme({
  palette: {
    primary: {
      main: "#0A74A0",
      dark: "#00527C",
      light: "#E9EFF3",
    },
    secondary: {
      main: "#19857b",
      dark: "#09cdda",
      light: "#09cdda",
    },
    error: { main: "#19857b" },
  },
  typography: {
    fontFamily: ["josefin-sans"].join(","),

    h1: {
      fontSize: "2rem",
      fontWeight: "bold",
    },
    h2: {
      fontSize: "1.5rem",
      fontWeight: "bold",
    },
    h3: {
      fontSize: "1.25rem",
    },
    subtitle1: {
      fontSize: "1.5rem",
      fontWeight: "bold",
    },
    body1: {
      fontSize: "1rem",
    },
    body2: {
      fontSize: "1rem",
      fontWeight: "bold",
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#00527C",
          boxShadow: "none",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          root: {
            backgroundColor: "#00527C",
            boxShadow: "none",
          },
        },
      },
    },
  },
});

export default theme;
